Translation = require 'components/mixins/translation'
HorizontalRadios = require './horizontal_radios'
EtdActions = require 'actions/etd_actions'
Button = require 'components/common/button'
EditButton = require 'components/common/edit_button'
SaveButton = require 'components/common/save_button'
DeleteButton = require 'components/common/delete_button'

ResourcesQuestions = createReactClass
  displayName: 'DetailedJudgementsResourcesQuestions'

  mixins: [Translation('es:recommendations.table')]

  propTypes:
    groupPrefix: PropTypes.string.isRequired
    sectionId: PropTypes.string.isRequired
    questions: PropTypes.object.isRequired

  getInitialState: ->
    editedResource: null

  changeResourceName: (questionIdx, resourceIdx) -> (e) =>
    value = e.currentTarget.value
    @_debouncedChangeResourceName ?= _.debounce(EtdActions.changeDetailedResourceName, 200)
    @_debouncedChangeResourceName @props.sectionId, questionIdx, resourceIdx, value,
      @props.isConsensus

  changeRadioOption: (questionIdx, resourceIdx) -> (value) =>
    EtdActions.updateDetailedResourcesQuestion @props.sectionId, questionIdx, resourceIdx, value,
      @props.isConsensus

  addResource: (questionIdx) -> =>
    @setState editedResource: null
    EtdActions.addDetailedResource @props.sectionId, questionIdx, @props.isConsensus

  saveResource: (questionIdx, resourceIdx) -> =>
    @setState editedResource: null

  editResource: (questionIdx, resourceIdx) -> =>
    @setState editedResource: "#{questionIdx}-#{resourceIdx}"

  deleteResource: (questionIdx, resourceIdx) -> =>
    @setState editedResource: null
    EtdActions.removeDetailedResource @props.sectionId, questionIdx, resourceIdx,
      @props.isConsensus

  isResourceEdited: (questionIdx, resourceIdx) ->
    @state.editedResource is "#{questionIdx}-#{resourceIdx}"

  _getQuestionResources: (question) ->
    if @props.isConsensus
      # passing draft_judgement resources as a notSetValue parameter here in case consenus
      # value is not set yet
      question.get 'resourcesConsensus', question.get('resources')
    else
      question.get('resources')

  render: ->
    <div className="resources-questions">
      {@props.questions.map (question, questionIdx) =>
        <div key={questionIdx} className="judgements-table-container">
          <span>{question.get 'question'}</span>
          <table className="judgements-table">
            <thead className="judgements-table-header">
              <tr className="judgement-table-row">
                <th>{if @props.anticipatedOutcomes
                  @i18n 'anticipated_outcomes'
                else
                  @i18n 'main_resources'}</th>
                <th colSpan=2>{@i18n 'judgements'}</th>
              </tr>
            </thead>
            <tbody>
              {(@_getQuestionResources(question) ? Immutable.List()).map (resource, resourceIdx) =>
                <tr key={resourceIdx} className="judgement-table-row">
                  <td className="resource-name">
                  {
                    if @isResourceEdited questionIdx, resourceIdx
                      <textarea
                        className="resource-name-editor"
                        defaultValue={resource.get 'name'}
                        onChange={@changeResourceName questionIdx, resourceIdx}
                      />
                    else
                      resource.get 'name'
                  }
                  </td>
                  <td>
                    <HorizontalRadios
                      editable={@props.editable}
                      groupName={"#{@props.groupPrefix}_resources_quesitons_#{resourceIdx}"}
                      options={question.get('options', Immutable.List())}
                      additionalOptions={question.get('additionalOptions', Immutable.List())}
                      selectedOption={resource.get('selectedOption')}
                      onChange={@changeRadioOption questionIdx, resourceIdx}
                    />
                  </td>
                  <td className="buttons-cell">
                    {if @isResourceEdited questionIdx, resourceIdx
                      [
                        <SaveButton
                          key='save-resource'
                          className='save-resource'
                          onClick={@saveResource questionIdx, resourceIdx}
                        />
                        <DeleteButton
                          key='delete-resource'
                          className='delete-resource'
                          onClick={@deleteResource questionIdx, resourceIdx}
                        />
                      ]
                    else
                      <EditButton
                        disabled={not @props.editable}
                        className="edit-resource"
                        onClick={@editResource questionIdx, resourceIdx}/>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <Button
            disabled={not @props.editable}
            className="btn btn-block add-resource-btn"
            label={if @props.anticipatedOutcomes
              @i18n 'add_anticipated_outcome'
            else
              @i18n 'add_resource'}
            onClick={@addResource questionIdx}
          />
        </div>
      }
    </div>

module.exports = ResourcesQuestions
